
export function subsReducer(
  state = {
    subsData: {}
  },
  action) {
  switch (action.type) {

    case 'SUBS_SET':
      // 
      return {
        ...state,
        subsData: action.val
      };

    default:
      return state;
  }
}
